import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useCallbackPrevention } from '../../internal/hooks/usePreventedEventCallback';
import { PromoModalAction, PromoModalActions, PromoModalActionSecondary, PromoModalBody, PromoModalCloseButton, PromoModalContent, PromoModalDescription, PromoModalFooter, PromoModalMedia, PromoModalRoot, PromoModalTitle } from './PromoModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Предсозданный компонент модального окна типа Promo
 */
export const PromoModal = /*#__PURE__*/React.memo(function PromoModal(_ref) {
  let {
    open,
    onOpenChange,
    size,
    width,
    onPrimaryAction,
    onSecondaryAction,
    preventEscape,
    preventOutside,
    hideCloseButton,
    title,
    description,
    actionText,
    secondaryActionText,
    media,
    closeButtonProps
  } = _ref;
  const preventCloseByInteractOutside = useCallbackPrevention(preventOutside);
  const preventCloseByEscape = useCallbackPrevention(preventEscape);
  return /*#__PURE__*/_jsx(PromoModalRoot, {
    onOpenChange: onOpenChange,
    open: open,
    modal: true,
    children: /*#__PURE__*/_jsxs(PromoModalContent, {
      size: size,
      onInteractOutside: preventCloseByInteractOutside,
      onEscapeKeyDown: preventCloseByEscape,
      style: {
        width
      },
      children: [!hideCloseButton && /*#__PURE__*/_jsx(PromoModalCloseButton, _objectSpread({
        theme: "fill_dark",
        size: "XS",
        icon: /*#__PURE__*/_jsx(IconActionClose16, {
          color: "current_color"
        }),
        title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
      }, closeButtonProps)), /*#__PURE__*/_jsx(PromoModalMedia, {
        children: media
      }), /*#__PURE__*/_jsxs(PromoModalBody, {
        children: [/*#__PURE__*/_jsx(PromoModalTitle, {
          children: title
        }), /*#__PURE__*/_jsx(PromoModalDescription, {
          children: description
        })]
      }), /*#__PURE__*/_jsx(PromoModalFooter, {
        children: /*#__PURE__*/_jsxs(PromoModalActions, {
          children: [secondaryActionText && onSecondaryAction && /*#__PURE__*/_jsx(PromoModalActionSecondary, {
            onClick: onSecondaryAction,
            children: secondaryActionText
          }), /*#__PURE__*/_jsx(PromoModalAction, {
            onClick: onPrimaryAction,
            children: actionText
          })]
        })
      })]
    })
  });
});